import { Select, Spin } from "antd";
import React from "react";
import { RadialBar, RadialBarChart } from "recharts";

const EmployeeStatus = ({
  capitalize,
  FetchFilteredData,
  dropDownValues,
  chartData,
  NoData,
  filter,
}) => {
  //console.log(capitalize, FetchFilteredData, dropDownValues, chartData, "EmployeeStatus Props")

  return (
    <>
      <div className="part_two__element">
        <div className="part_two__header" style={{ padding: "10px" }}>
          <p>Employees Status</p>
          <Select
            size="small"
            onChange={(value) => {
              FetchFilteredData("employee_status", value.value);
            }}
            labelInValue
            defaultValue={{
              value: "All",
              label: "All",
            }}
            style={{
              width: 100,
            }}
            options={dropDownValues}
          />
        </div>
        <Spin spinning={filter === "employee_status" ? true : false}>
          <div className="part_two__container">
            {chartData ? (
              <div className="part_two__content emp_status">
                <RadialBarChart
                  label={{ position: "insideStart", fill: "#fff" }}
                  startAngle={90}
                  endAngle={480}
                  width={230}
                  height={250}
                  margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                  data={chartData}
                  innerRadius="20%"
                  outerRadius="90%"
                >
                  <RadialBar
                    cornerRadius={28 / 2}
                    background
                    minAngle={0}
                    dataKey="x"
                    legendType="square"
                  />
                </RadialBarChart>
                <div className="part_two__sub_content">
                  <div className="part_two__chart_stats">
                    <p>Active</p>
                    <span style={{ color: "#A020F0" }}>
                      {" "}
                      {chartData && chartData[2] && chartData[2].x
                        ? chartData[2].x
                        : 0}
                    </span>
                  </div>
                  <div className="part_two__chart_stats">
                    <p>Inactive</p>
                    <span style={{ color: "#35b8cc" }}>
                      {chartData && chartData[1] && chartData[1].x
                        ? chartData[1].x
                        : 0}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "28.5rem",
                }}
              >
                <img
                  src={NoData}
                  alt="No Data"
                  style={{ width: "100px", height: "100px" }}
                />
              </div>
            )}
          </div>
        </Spin>
      </div>
    </>
  );
};

export default EmployeeStatus;
